import { useTranslation } from 'react-i18next';

export default function Hero() {
  const { t } = useTranslation('common');

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img 
          src="https://public.readdy.ai/ai/img_res/e4bae39370ea71599f5620f4d393d8a3.jpg"
          alt="Background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
      </div>
      
      <div className="relative z-10 max-w-5xl mx-auto px-8 text-center w-full">
        <div className="mb-6">
          <span className="inline-block px-5 py-2 bg-amber-600/20 backdrop-blur-sm border border-amber-500/30 rounded-full text-amber-300 text-sm font-medium">
            {t('hero.badge')}
          </span>
        </div>
        
        <h2 className="text-6xl md:text-7xl font-bold text-white mb-6 leading-tight">
          {t('hero.title1')}<br />
          <span className="font-light italic">{t('hero.title2')}</span><br />
          {t('hero.title3')}
        </h2>
        
        <p className="text-xl text-gray-200 mb-10 max-w-3xl mx-auto leading-relaxed">
          {t('hero.description')}
        </p>
        
        <div className="flex items-center justify-center gap-5">
          <a href="#contact" className="px-8 py-4 bg-amber-600 text-white text-base font-semibold rounded-full hover:bg-amber-700 transition-all whitespace-nowrap cursor-pointer">
            {t('hero.cta1')}
          </a>
          <a href="#about" className="px-8 py-4 bg-white/10 backdrop-blur-sm text-white text-base font-semibold rounded-full hover:bg-white/20 transition-all whitespace-nowrap cursor-pointer border border-white/30">
            {t('hero.cta2')}
          </a>
        </div>
      </div>
    </section>
  );
}
